import { render, staticRenderFns } from "./EmployeeData.vue?vue&type=template&id=f1f2378e&scoped=true&"
import script from "./EmployeeData.vue?vue&type=script&lang=js&"
export * from "./EmployeeData.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeData.vue?vue&type=style&index=0&id=f1f2378e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1f2378e",
  null
  
)

export default component.exports